import { useMediaQuery } from 'usehooks-ts'

// TODO: After migrating to Tailwind 4, consider using CSS variables for breakpoints
const useMobile = () => {
	return useMediaQuery('(max-width: 767px)', {
		// TODO: Change this to false for SSR in FE-3646
		// We can't change this right now due to a problems with zustand stores
		initializeWithValue: true
	})
}

const useTablet = () => {
	return useMediaQuery('(min-width: 768px) and (max-width: 1279px)', {
		// TODO: Change this to false for SSR in FE-3646
		// We can't change this right now due to a problems with zustand stores
		initializeWithValue: true
	})
}

const useDesktop = () => {
	return useMediaQuery('(min-width: 1280px)', {
		// TODO: Change this to false for SSR in FE-3646
		// We can't change this right now due to a problems with zustand stores
		initializeWithValue: true
	})
}

export { useMobile, useTablet, useDesktop }
